module.exports = __webpack_public_path__ + "img/Slide14.15a84b77.png";